import React, { useState } from "react";
import { Button } from "@mui/material";
import PropTypes from "prop-types";
import organizationService from "services/organizationService";
import ModalComponent from "components/ModalComponent/ModalComponent";
import OrganizationDetailsForm from "components/Forms/OrganizationDetailsForm";
import AlertComponent from "components/AlertComponent/AlertComponent";

import noPicture from "components/Tables/no-picture.svg";
import tagAdminConstants from "constants/tagAdminConstants";

function OrganizationDetails({ organization, fetchAllApiData }) {
  const [openModal, setOpenModal] = useState(false);
  const [orgWithUser, setOrgWithUser] = useState({});
  const [stateAlert, setStateAlert] = useState({
    emailAlertError: false,
    elailAlertSuccess: false,
    resetPosswordAlertError: false,
    resetPosswordAlertSuccess: false,
    lockUserAlertError: false,
    lockUserAlertSuccess: false,
    deleteUserAlertError: false,
    deleteUserAlertSuccess: false,
    organizationActivateSuccess: false,
    organizationActivateError: false,
    organizationBlockSuccess: false,
    organizationBlockError: false,
    alertStatename: "",
    mesage: "",
    varient: "",
  });
  const closeAlertModel = (statename) => {
    setStateAlert((prev) => ({
      ...prev,
      [statename]: false,
    }));
  };
  const openAlertModel = (statename, message, variant, alertstateName) => {
    setStateAlert((prev) => ({
      ...prev,
      [statename]: true,
      mesage: message,
      varient: variant,
      alertStatename: alertstateName,
    }));
  };
  const getOrganizationWithUser = (org) => {
    organizationService.getOrgWithUser(org.id).then((res) => {
      if (res.status === 200) {
        setOrgWithUser(res.data);
        setOpenModal(true);
      }
    });
  };
  const organizationModalOpen = (org) => {
    getOrganizationWithUser(org);
  };

  return (
    <div className="b-org-detail-container">
      <AlertComponent
        title={stateAlert.mesage}
        msg={stateAlert.varient}
        handleCloseAlert={() => closeAlertModel(stateAlert.alertStatename)}
        openAlert={stateAlert[stateAlert.alertStatename]}
      />
      <ModalComponent
        title={organization.title}
        openModal={openModal}
        isLocked={organization.is_blocked}
        handleCloseModal={() => setOpenModal(false)}
        ModalBody={
          <OrganizationDetailsForm
            org={organization}
            fetchAllApiData={fetchAllApiData}
            getOrganizationWithUser={getOrganizationWithUser}
            orgWithUser={orgWithUser}
            handleCloseModal={() => setOpenModal(false)}
            openAlertModel={openAlertModel}
          />
        }
      />
      <div className="b-org-detail-container__header">
        <img
          className="b-org-detail-container__img"
          src={`${organization.logo ? organization.logo : noPicture}`}
          alt=""
          onError={({ currentTarget }) => {
            // eslint-disable-next-line
            currentTarget.onerror = null; // prevents looping
            // eslint-disable-next-line
            currentTarget.src = noPicture;
          }}
        />
        {/* Email */}
        <div className="b-org-detail-container__textSection">
          <span className="b-org-detail-container__textSpan">
            Primary Email
          </span>
          <br />
          <span className=" b-org-detail-container__textLabel">
            {organization.email}
          </span>
        </div>
        <div className=" b-org-detail-container__textDiv">
          <span className="b-org-detail-container__textSpan">Address</span>
          <br />
          <span className=" b-org-detail-container__labelText">
            {organization.address}
          </span>
        </div>
        <div className=" b-org-detail-container__textDiv">
          <span className="b-org-detail-container__textSpan">
            Organization Type
          </span>
          <br />
          <span className=" b-org-detail-container__labelText">
            {organization.organization_type ===
            tagAdminConstants.APP_MODE.FULL.key
              ? tagAdminConstants.APP_MODE.FULL.value
              : tagAdminConstants.APP_MODE.LIGHT.value}
          </span>
        </div>
        <div className=" b-org-detail-container__textDiv">
          <span className="b-org-detail-container__textSpan">Domain</span>
          <br />
          <span className=" b-org-detail-container__labelText">
            {organization.sub_domain}
          </span>
        </div>
        {/* Button */}
        <div className="b-org-detail-container__buttonTxt">
          <Button
            className="b-org-detail-container__viewMore"
            variant="outlined"
            onClick={() => organizationModalOpen(organization)}
          >
            View More
          </Button>
        </div>
      </div>
    </div>
  );
}
OrganizationDetails.propTypes = {
  organization: PropTypes.oneOfType([PropTypes.object]).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  handleOrgData: PropTypes.func,
  fetchAllApiData: PropTypes.func.isRequired,
};

OrganizationDetails.defaultProps = {
  handleOrgData: undefined,
};

export default OrganizationDetails;
